import {Component, Input, OnChanges} from '@angular/core';
import {NavItem} from '../../../../../../models/nav-item.model';
import {NavService} from '../../../../../../services/nav.service';
import {NavItemCodes} from '../../../../../../enums/nav-item-codes.enum';

@Component({
    selector: 'app-card-footer',
    templateUrl: './card-footer.component.html',
    styleUrls: ['./card-footer.component.less']
})
export class CardFooterComponent implements OnChanges {
    @Input() code: NavItemCodes | string;
    @Input() actions: NavItem[] = [];
    item: NavItem;

    ngOnChanges() {
        this.item = NavService.get(this.code);
    }
}
